
import React, { useState, useEffect } from "react";
//import { useParams } from "react-router-dom";
import axios from "axios";
import apiUrl from "../../environment/Api";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

function StudentReport() {
  //   const { id } = useParams();
  const [filtered, setFiltered] = useState([]);
  const [courses, setCourses] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});
  const [branch, setbranch] = useState([])
  const [Branches, setselectBranch] = useState([])
  const [loading, setLoading] = useState(false)


  const [uniquestudent, setuniquestudent] = useState([]);




  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // const leadsResponse = await axios.get(apiUrl + "/studingstudent");
        const leadsResponse = await axios.get(apiUrl + "/student_dairy_overall");
        setFiltered(leadsResponse.data);


        const branchresponse = await axios.get(apiUrl + "/branch");
        console.log("Branch response:", branchresponse.data);


        if (Array.isArray(branchresponse.data)) {
          setbranch(branchresponse.data);
        } else {
          console.error("Unexpected data format:", branchresponse.data);
        }


        // new code to set the unique course
        const uniqueCourses = leadsResponse.data.reduce((acc, item) => {
          if (!acc.some((obj) => obj.course === item.course)) {
            acc.push(item);
          }
          return acc;
        }, []);

        setCourses(uniqueCourses);

        // new code to set the unique course
        const uniquestudent = leadsResponse.data.reduce((acc, item) => {
          if (!acc.some((obj) => obj.student === item.student)) {
            acc.push(item);
          }
          return acc;
        }, []);

        // setuniquestudent(uniquestudent);

        setStatuses(uniquestudent);

        console.log("The uniquestudent in the fetch data is : ", uniquestudent);



        // // Extract unique courses from the response
        // const uniqueCourses = Array.from(
        //   new Set(
        //     leadsResponse.data.map((item) => item.leads_id[0]?.Prefered_course)
        //   )
        // ).map((course) => ({ course_name: course }));
        // setCourses(uniqueCourses);

        // // Extract unique statuses from the response
        // const uniqueStatuses = Array.from(
        //   new Set(leadsResponse.data.map((item) => item.followups_status_lead)) // Ensure followups_status is available
        // ).map((status) => ({ followups_status_lead: status }));
        // setStatuses(uniqueStatuses); // Set the statuses

      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setTimeout(
        () => {
          setLoading(false)
        }, 500
      )
    };

    fetchData();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const formatDatefitching = (date) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(date).toLocaleDateString(undefined, options);
  };

  // ============= code to format the date ===================================
  const formatDate = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);

    const day = date.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single-digit months
    const year = date.getFullYear();

    return `${day}-${month}-${year}`; // Format as "day-month-year"
  };
  // ============= code to format the date ===================================


  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;

  // // this code is used for the route 'studingstudent'
  // const filteredData = filtered.filter((item) => {
  //   const branch = item.branch_details[0];
  //   const lead = item.leads_id[0]; // Accessing the first element of leads_id array

  //   // Handling search term filtering
  //   const isSearchMatch = searchTerm
  //     ? (lead?.student_name &&
  //         lead.student_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
  //       (lead?.mobile_no && String(lead.mobile_no).includes(searchTerm)) ||
  //       (branch?.branch_name &&
  //         branch.branch_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
  //       (lead?.Prefered_course &&
  //         lead.Prefered_course.toLowerCase().includes(searchTerm.toLowerCase())) ||
  //       (item.fees && String(item.fees).includes(searchTerm))
  //     : true;

  //   // Check if selected course matches
  //   const isCourseMatch = selectedCourse
  //     ? lead?.Prefered_course === selectedCourse
  //     : true;

  //   // Check if selected branch matches
  //   const isBranchMatch = Branches
  //     ? branch?.branch_name === Branches
  //     : true;

  //   // Check if selected status matches
  //   const isStatusMatch = selectedStatus
  //     ? lead?.followups_status_lead === selectedStatus
  //     : true;

  //   // Return true if all conditions are met
  //   return isSearchMatch && isCourseMatch && isStatusMatch && isBranchMatch;
  // });


  // this code is used for the route 'student_dairy_overall'
  const filteredData = filtered.filter((item) => {
    // const branch = item.branch_details[0];
    // const lead = item.leads_id[0]; // Accessing the first element of leads_id array

    // Handling search term filtering
    const isSearchMatch = searchTerm
      ? (item?.student &&
        item.student.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item.branch_id?.branch_name &&
        item.branch_id?.branch_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item?.course &&
        item.course.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item?.login &&
        item.login.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item?.logout &&
        item.logout.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item?.topic_covered &&
        item.topic_covered.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item?.subtopic &&
        item.subtopic.toLowerCase().includes(searchTerm.toLowerCase()))
      : true;

    // Check if selected course matches
    const isCourseMatch = selectedCourse
      ? item?.course === selectedCourse
      : true;

    // // Check if selected branch matches  
    // const isBranchMatch = Branches
    //   ? item?.branch_name === Branches
    //   : true;

    // Check if selected branch matches  
    const isBranchMatch = Branches
      ? item.branch_id?.branch_name === Branches
      : true;

    // // Check if selected status matches   
    // const isStatusMatch = selectedStatus
    //   ? item?.followups_status_lead === selectedStatus
    //   : true;

    // Check if selected status matches
    const isStatusMatch = selectedStatus
      ? item?.student === selectedStatus
      : true;

    // code for check the date filter 
    const itemEnquiryDate = new Date(item.date);
    const isFromDateMatch = fromDate
      ? itemEnquiryDate >= new Date(fromDate)
      : true;
    const isToDateMatch = toDate ? itemEnquiryDate <= new Date(toDate) : true;

    // // check if selected student matches
    // const isStudentMatch = uniquestudent
    //   ? item?.student === uniquestudent
    //   : true;

    // Return true if all conditions are met
    // return isSearchMatch && isCourseMatch && isStatusMatch && isBranchMatch;
    return isSearchMatch && isCourseMatch && isStatusMatch && isBranchMatch && isFromDateMatch && isToDateMatch;
  });

  const currentEntries = filteredData.slice(
    indexOfFirstEntry,
    indexOfLastEntry
  );

  const handleEntriesPerPageChange = (event) => {
    setEntriesPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleBranchChange = (event) => {
    setselectBranch(event.target.value);
    setCurrentPage(1);

    if (event.target.value == "") {
      const uniquestudent = filtered.reduce((acc, item) => {
        if (!acc.some((obj) => obj.student === item.student)) {
          acc.push(item);
        }
        return acc;
      }, []);

      // setuniquestudent(uniquestudent);

      setStatuses(uniquestudent);
    }
    else {

      let uniquestudent = filtered.filter(
        (item) => item.branch_id?.branch_name.trim().toLowerCase() === event.target.value.trim().toLowerCase()
      );

      uniquestudent = uniquestudent.reduce((acc, item) => {
        if (!acc.some((obj) => obj.student === item.student)) {
          acc.push(item);
        }
        return acc;
      }, []);

      setStatuses(uniquestudent);
    }

  };

  const handleCourseChange = (event) => {
    setSelectedCourse(event.target.value);
    setCurrentPage(1);
  };

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
    // setuniquestudent(event.target.value);
    setCurrentPage(1);
  };

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  // =========== code to fetch the data at initially ================
  useEffect(() => {
    handleClearFilters();
  }, []);
  // =========== code to fetch the data at initially ================

  const handleClearFilters = () => {
    setSelectedCourse("");
    setSelectedStatus("");
    setselectBranch("");
    setFromDate("");
    setToDate("");
    setSearchTerm("");
    // setuniquestudent("");
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  const handleCopy = () => {
    const tableElement = document.getElementById("tableId");
    if (tableElement) {
      const tableData = tableElement.innerText;
      navigator.clipboard
        .writeText(tableData)
        .then(() => {
          alert("Student Table data copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    } else {
      console.error("Table with ID 'tableId' not found");
    }
  };

  // this is old code 
  // const handleCSVExport = () => {
  //   const csvHeaders = [
  //     "S.No",
  //     "Name",
  //     "Mobile No",
  //     "Course",
  //     "Source Type",
  //     "Enquiry Date",
  //     "followups_status_lead",
  //   ];
  //   const csvData = filteredData.map((item, index) => [
  //     index + 1,
  //     item.student_name,
  //     item.mobile_no,
  //     item.Prefered_course,
  //     item.Source_type,
  //     formatDatefitching(item.Enquiry_date),
  //     item.followups_status_lead,
  //   ]);

  //   const csvContent = [
  //     csvHeaders.join(","), // Headers
  //     ...csvData.map((row) => row.join(",")), // Data rows
  //   ].join("\n");

  //   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  //   const link = document.createElement("a");
  //   link.href = URL.createObjectURL(blob);
  //   link.setAttribute("download", "student_report.csv");
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  const handleCSVExport = () => {
    const csvHeaders = [
      "S.No",
      "Branch",
      "Student",
      "Course",
      "Date",
      "Login",
      "Logout",
      "Topic Covered",
      "Sub Topic"
    ];
    const csvData = filteredData.map((item, index) => [
      index + 1,
      item.branch_id?.branch_name,
      item.student,
      item.course,
      // formatDatefitching(item.date),
      formatDate(item.date),
      item.login,
      item.logout,
      item.topic_covered,
      item.subtopic
    ]);

    const csvContent = [
      csvHeaders.join(","), // Headers
      ...csvData.map((row) => row.join(",")), // Data rows
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "Student_Report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExport = () => {
    const tableElement = document.getElementById("tableId");
    if (tableElement) {
      const worksheet = XLSX.utils.table_to_sheet(tableElement);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, "Student_Report.xlsx");
    } else {
      console.error(
        "Table with ID 'tableId' not found. Check if the table is rendered in the DOM."
      );
    }
  };



  // const handleGeneratePDF = () => {
  //   const tableElement = document.getElementById("tableId");
  //   if (!tableElement) {
  //     console.error("Table with ID 'tableId' not found");
  //     return;
  //   }
  
  //   html2canvas(tableElement)
  //     .then((canvas) => {
  //       const imgData = canvas.toDataURL("image/png");
  
  //       // Calculate the image height based on the width (scaling for the PDF)
  //       const imgHeight = (canvas.height * 190) / canvas.width;
  
  //       const pdf = new jsPDF();
  
  //       // Add the title text at the top of the PDF
  //       pdf.setFontSize(23);
  //       pdf.text("Student Report", 20, 20); // Add title
  
  //       // Add the table image below the title
  //       pdf.addImage(imgData, "PNG", 10, 30, 190, imgHeight); // Adjust the y position for image accordingly
  
  //       // Save the PDF
  //       pdf.save("Student_Report.pdf");
  //     })
  //     .catch((error) => {
  //       console.error("Error generating PDF: ", error);
  //     });
  // };
  

  const handleGeneratePDF = () => {
    const tableElement = document.getElementById("tableId");
    if (!tableElement) {
      console.error("Table with ID 'tableId' not found");
      return;
    }
  
    html2canvas(tableElement, { scale: 2, useCORS: true }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.95);
      const pdf = new jsPDF();
  
      const pageWidth = pdf.internal.pageSize.width;
      const pageHeight = pdf.internal.pageSize.height;
      const marginX = 10;
      const marginY = 20;
      const imgWidth = pageWidth - 2 * marginX;
      let imgHeight = (canvas.height * imgWidth) / canvas.width;
  
      let positionY = marginY + 10; // Start below the title
      pdf.setFontSize(23);
      pdf.text("Student Report", pageWidth / 2, marginY, { align: "center" });
  
      let remainingHeight = imgHeight;
      let sourceY = 0;
      let pageNumber = 1;
  
      while (remainingHeight > 0) {
        const cropHeight = Math.min(pageHeight - (marginY + 20), remainingHeight);
        const pageCanvas = document.createElement("canvas");
        pageCanvas.width = canvas.width;
        pageCanvas.height = Math.floor(cropHeight * (canvas.width / imgWidth));
        const pageCtx = pageCanvas.getContext("2d");
  
        // ✅ Fix: Ensure proper cropping and avoid cutting off table rows
        pageCtx.drawImage(
          canvas,
          0, sourceY, canvas.width, pageCanvas.height,
          0, 0, pageCanvas.width, pageCanvas.height
        );
  
        const croppedImg = pageCanvas.toDataURL("image/jpeg", 0.95);
        pdf.addImage(croppedImg, "JPEG", marginX, positionY, imgWidth, cropHeight);
  
        remainingHeight -= cropHeight;
        sourceY += pageCanvas.height;
  
        if (remainingHeight > 0) {
          pdf.addPage();
          pageNumber++;
          positionY = marginY;
  
          // ✅ Add page number at the bottom
          pdf.setFontSize(12);
          pdf.text(`Page ${pageNumber}`, pageWidth / 2, pageHeight - 10, { align: "center" });
        }
      }
  
      pdf.save("Student_Report.pdf");
    }).catch((error) => {
      console.error("Error generating PDF: ", error);
    });
  };
  
  
  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    const tableElement = document.getElementById("tableId");
    if (tableElement) {
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Student Table</title>
            <style>
              table { width: 100%; border-collapse: collapse; }
              th, td { border: 1px solid #000; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; }
            </style>
          </head>
          <body>
            <h1>Student Report</h1>
            <div>${tableElement.outerHTML}</div>
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    } else {
      console.error("Table with ID 'tableId' not found");
    }
  };




  useEffect(() => {
    gettoken();
    getprevillages();
  }, []);


  const gettoken = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);

      setroleid(response.data.detail.rolename);

      localStorage.setItem("role_id", response.data.detail.rolename);

      const id = response.data.detail.rolename;

      if (id) { }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const getprevillages = () => {
    const username = JSON.parse(localStorage.getItem("user_previllages"));
    console.log("tyhe username get by local stroage : ", username.modules);
    const total_previlages = username.modules;
    const new_enquiry = total_previlages.find((item) => item.name == "Student Report")
    console.log("the new_enquiry is : ", new_enquiry.actions);

    setprevillages(new_enquiry.actions)
  }



  const paginate = (pageNumber) => setCurrentPage(pageNumber);


  const createPagination = () => {
    let liTag = [];
    let beforePage = currentPage - 1;
    let afterPage = currentPage + 1;
    let active;

    if (currentPage > 1) {
      liTag.push(
        <li className="page-item" key="prev">
          <button
            className="page-link"
            onClick={() => paginate(currentPage - 1)}
          >
            <FaAngleLeft /> Prev
          </button>
        </li>
      );
    }

    if (currentPage > 2) {
      liTag.push(
        <li className="page-item" key="first" onClick={() => paginate(1)}>
          <button className="page-link">1</button>
        </li>
      );
      if (currentPage > 3) {
        liTag.push(
          <li className="page-item disabled" key="dots1">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    if (currentPage === totalPages) {
      beforePage -= 2;
    } else if (currentPage === totalPages - 1) {
      beforePage -= 1;
    }

    if (currentPage === 1) {
      afterPage += 2;
    } else if (currentPage === 2) {
      afterPage += 1;
    }

    for (let plength = beforePage; plength <= afterPage; plength++) {
      if (plength > totalPages || plength <= 0) continue;
      active = currentPage === plength ? "active" : "";
      liTag.push(
        <li
          className={`page-item ${active}`}
          key={plength}
          onClick={() => paginate(plength)}
        >
          <button className="page-link">{plength}</button>
        </li>
      );
    }

    if (currentPage < totalPages - 1) {
      if (currentPage < totalPages - 2) {
        liTag.push(
          <li className="page-item disabled" key="dots2">
            <span className="page-link">...</span>
          </li>
        );
      }
      liTag.push(
        <li
          className="page-item"
          key="last"
          onClick={() => paginate(totalPages)}
        >
          <button className="page-link">{totalPages}</button>
        </li>
      );
    }

    if (currentPage < totalPages) {
      liTag.push(
        <li className="page-item" key="next">
          <button
            className="page-link"
            onClick={() => paginate(currentPage + 1)}
          >
            Next <FaAngleRight />
          </button>
        </li>
      );
    }

    return liTag;
  };



  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}
      <div className="container-fluid mt-3">
        <div
          className="card p-2"
          style={{
            marginTop: "-80px",
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          }}
        >
          <div className="row ">
            <h6 className="mt-3" style={{color:"#8f0505"}}>
              <b className="">Student Report</b>
            </h6>
          </div>
          <hr />
          <div className="row p-2">
            <div className="col-lg-2 col-md-3 col-sm-12 mx-3">
              <input
                type="date"
                value={fromDate}
                onChange={handleFromDateChange}
                className="form-control"
              />
            </div>
            <div className="col-lg-2 col-md-3 col-sm-12">
              <input
                type="date"
                value={toDate}
                onChange={handleToDateChange}
                className="form-control"
              />
            </div>

            <div className="col-lg-2 col-md-3 col-sm-12">
              <select
                value={Branches} // Ensure this matches the state variable for the selected branch
                // onChange={(e) => setselectBranch(e.target.value)} // Update the state
                onChange={handleBranchChange}
                className="form-control"
              >
                <option value="">All Branches</option>
                {branch.map((branchItem) => (
                  <option key={branchItem._id} value={branchItem?.branch_name}>
                    {branchItem.branch_name}
                  </option>
                ))}
              </select>
            </div>
            {/* <div className="col-lg-2 col-md-3 col-sm-12">
            <select
              value={selectedCourse}
              onChange={handleCourseChange}
              className="form-control"
            >
              <option value="">Select Course</option>
              {courses.map((course, index) => (
                <option key={index} value={course.course_name}>
                  {course.course_name}
                </option>
              ))}
            </select>
          </div> */}
            <div className="col-lg-2 col-md-3 col-sm-12">
              <select
                value={selectedCourse}
                onChange={handleCourseChange}
                className="form-control"
              >
                <option value="">Select Course</option>
                {courses.map((course, index) => (
                  <option key={index} value={course.course}>
                    {course.course}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-lg-2 col-md-3 col-sm-12">
              <select
                value={selectedStatus}
                onChange={handleStatusChange}
                className="form-control"
              >
                <option value="">Select Student</option>
                {statuses.map((status, index) => (
                  <option key={index} value={status.student}>
                    {status.student}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-lg-1 col-md-2 col-sm-12">
              <button className="btn btn-danger" onClick={handleClearFilters}>
                Clear
              </button>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-3 d-flex align-items-center">
              <p className="mb-0 mr-2">Show</p>
              <select
                value={entriesPerPage}
                onChange={handleEntriesPerPageChange}
                className="form-control mx-2"
                style={{ width: "50px" }}
              >
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={filteredData.length}>All</option>
              </select>
            </div>

            <div className="col-md-6">
              {previllages.download && (
                <button className="btn btn-secondary2 mx-2" onClick={handleCopy}>
                  Copy
                </button>
              )}

              {previllages.download && (
                <button className="btn btn-success2 mx-2" onClick={handleCSVExport}>
                  CSV
                </button>)}

              {previllages.download && (
                <button className="btn btn-excel2 mx-2" onClick={handleExport}>
                  Excel
                </button>
              )}
              {previllages.download && (
                <button className="btn btn-info2 mx-2" onClick={handleGeneratePDF}>
                  PDF
                </button>
              )}
              {previllages.download && (
                <button className="btn btn-warning2 mx-2" onClick={handlePrint}>
                  Print
                </button>
              )}
            </div>

            <div className="col-md-3 d-flex align-items-center">
              <input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={handleSearchChange}
                className="form-control"
              />
            </div>
          </div>

          {/* this code is used for the route 'studingstudent' */}

          {/* <table id="tableId" className="table table-striped table-bordered mt-2">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Branch</th>
              <th>Student name</th>
              <th>Prefered course</th>
              <th>Mobile no</th>
              <th>fees</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {currentEntries.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1 + (currentPage - 1) * entriesPerPage}</td>
                 <td>{item.branch_details[0]?.branch_name}</td>
                <td>
                  {item.roll_no} &nbsp; - &nbsp;
                  {item.leads_id[0]?.student_name}
                </td>
               
                <td>{item.leads_id[0]?.Prefered_course}</td>
                <td>{item.leads_id[0]?.mobile_no}</td>
                <td>{item.fees}</td>
                <td>{item.followups_status_lead}</td>
              </tr>
            ))}
          </tbody>
        </table> */}

          {/* this code is used for the route 'student_dairy_overall' */}
          <table id="tableId" className="table table-striped table-bordered mt-2">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Branch</th>
                <th>Student</th>
                <th>Course</th>
                <th>Date</th>
                <th>Login</th>
                <th>Logout</th>
                <th>Topic Covered</th>
                <th>Sub Topic</th>
              </tr>
            </thead>
            <tbody>
              {currentEntries.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1 + (currentPage - 1) * entriesPerPage}</td>
                  <td>{item.branch_id?.branch_name}</td>
                  <td>{item?.student}</td>
                  <td>{item?.course}</td>

                  <td>{formatDate(item.date)}</td>
                  <td>{item?.login}</td>
                  <td>{item?.logout}</td>
                  <td>{item?.topic_covered}</td>
                  <td>{item?.subtopic}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="row">
            <div className="col-lg-4">
              <div className="dataTables_info" role="status" aria-live="polite">
                Showing {indexOfFirstEntry + 1} to{" "}
                {Math.min(indexOfLastEntry, filtered.length)} of {filtered.length}{" "}
                entries
              </div>
            </div>
            <div className="col-lg-5"></div>


            <div className="row">
              <div className="mt-3 pb-5">
                <div className="row">
                  <div className="col-lg-7 col-sm-12 mt-1">
                    <span className="text-dark">
                      Page {currentPage} of {totalPages}
                    </span>
                  </div>
                  <div className="col-lg-5">
                    <nav>
                      <ul className="pagination justify-content-center">
                        {createPagination()}
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentReport;
